import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Label,
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Dropdown,
  Input
} from 'semantic-ui-react'

const CardPayingUX = (props: any) => {
    return(
      <div
        id="CardPayingUX-div-0"
        style={{ width : "100%", height: "100%", padding: "10px", marginTop:"-1rem" }}>
        <div
          id="CardPayingUX-div-1"
          style={{"width":"100%","height":"100%","display":"grid","position":"relative","rowGap":"5px","gridTemplateColumns":"repeat(8, 1fr)"}}>
          <div
            id="CardPayingUX-div-2"
            style={{ padding: "10px", gridRow: "1/2", gridColumn: "1/3",display: "none"  }}>
            <Label
              className="ribbon large title blue"
              id="CardPayingUX-Label-69">
              {props.patientNameAndHN}
            </Label>
          </div>
          <div
            id="CardPayingUX-div-3"
            style={{ padding: "10px", gridRow: "1/2", gridColumn: "3/6",display: "none" }}>
            <Label
              className="large tag blue"
              id="CardPayingUX-Label-68">
              {`${props.citizenID || "-"}`}
            </Label>
          </div>
          <div
            id="CardPayingUX-div-4"
            style={{ gridRow: "1/2", gridColumn: "7/9",display: "none"}}>
            <div
              id="CardPayingUX-div-64"
              style={{ fontSize: "1.2rem", paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
              {props.languageUX === "en" ? "Paying" : "รับชำระเงิน (Paying)"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-89"
            style={{ gridRow: "3/4", gridColumn: "1/9", padding: "10px", display: "flex", margin: "0.5rem 0" }}>
            
            <Label
              className="ribbon large title blue"
              id="CardPayingUX-Label-90">
              {props.patientNameAndHN}
            </Label>
            <Label
              className="large tag blue"
              id="CardPayingUX-Label-91"
              style={{marginLeft: "5rem"}}>
              {`${props.citizenID || "-"}`}
            </Label>
            <div
              id="CardPayingUX-div-92"
              style={{flex:1}}>
              
            </div>
            <div
              id="CardPayingUX-div-130"
              style={{ display: "flex" }}>
              
              <div
                id="CardPayingUX-div-93"
                style={{ fontSize: "1.2rem", paddingRight: "10px",  height: "100%", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
                {props.languageUX === "en" ? "Paying" : "รับชำระเงิน (Paying)"}
              </div>
              <div
                id="CardPayingUX-div-132"
                style={{marginLeft: "5px", width: "250px"}}>
                
                <Label
                  color="blue"
                  id="CardPayingUX-Label-133"
                  style={{ fontSize: "1.2rem", paddingRight: "10px",  height: "100%", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                  {props.receiptCode}
                </Label>
              </div>
            </div>
          </div>
          <div
            id="CardPayingUX-div-5"
            style={{ gridRow: "4/5", gridColumn: "1/2",  }}>
            
            <div
              id="CardPayingUX-div-37"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", fontWeight: "bold" }}>
              {props.languageUX === "en" ? "Total expenses" : "ค่าใช้จ่ายทั้งหมด"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-6"
            style={{ gridRow: "4/5", gridColumn: "2/4", margin: "2.5px 0"  }}>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-48"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              {props.sumAmount.price}
            </div>
          </div>
          <div
            id="CardPayingUX-div-7"
            style={{ gridRow: "5/6", gridColumn: "1/2",  }}>
            
            <div
              id="CardPayingUX-div-38"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Claimable" : "เบิกได้"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-8"
            style={{ gridRow: "5/6", gridColumn: "2/4", margin: "2.5px 0"  }}>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-49"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.sumAmount.reimbursable}
            </div>
          </div>
          <div
            id="CardPayingUX-div-9"
            style={{ gridRow: "6/7", gridColumn: "1/2",  }}>
            <div
              id="CardPayingUX-div-39"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", fontWeight: "bold" }}>
              {props.languageUX === "en" ? "Non Claimable" : "เบิกไม่ได้"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-10"
            style={{ gridRow: "6/7", gridColumn: "2/4", margin: "2.5px 0"  }}>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-50"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {(props.sumAmount.cashonly || 0)}
            </div>
          </div>
          <div
            id="CardPayingUX-div-11"
            style={{ gridRow: "7/8", gridColumn: "1/2",  }}>
            <div
              id="CardPayingUX-div-40"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "discount" : "ส่วนลด"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-12"
            style={{ gridRow: "7/8", gridColumn: "2/4", margin: "2.5px 0"  }}>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-51"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {(props.sumAmount.discount || 0)}
            </div>
          </div>
          <div
            id="CardPayingUX-div-13"
            style={{ gridRow: "8/9", gridColumn: "1/2", }}>
            <div
              id="CardPayingUX-div-41"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", fontWeight: "bold" }}>
              {props.languageUX === "en" ? "Must pay" : "ต้องชำระ"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-14"
            style={{ gridRow: "8/9", gridColumn: "2/4", margin: "2.5px 0"  }}>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-52"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {(props.sumAmount.payable || 0)}
            </div>
          </div>
          <div
            id="CardPayingUX-div-15"
            style={{ gridRow: "9/10", gridColumn: "1/2",  }}>
            <div
              id="CardPayingUX-div-42"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Overdue" : "ค้างชำระ"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-16"
            style={{ gridRow: "9/10", gridColumn: "2/4", margin: "2.5px 0" }}>
            <div
              className={`ui label large fluid ${Number(props.rawOweText) > Number(props.totalText) ? "red" : "green"}`}
              id="CardPayingUX-div-53"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.oweText}
            </div>
          </div>
          <div
            id="CardPayingUX-div-17"
            style={{ gridRow: "4/5", gridColumn: "4/5", }}>
            <div
              id="CardPayingUX-div-43"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "cash" : "เงินสด"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-18"
            style={{ gridRow: "4/5", gridColumn: "5/7",  }}>
            <div
              className="ui input"
              id="CardPayingUX-div-54"
              style={{ width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              
              <input
                id="CardPaying-Input-CashAmount"
                onBlur={props.onBlurCashAmountText}
                onChange={props.onChangeCashAmountText}
                onKeyUp={props.onEnterCashAmountText}
                style={{  textAlign: "right" }}
                value={props.cashAmountText}>
              </input>
            </div>
          </div>
          <div
            id="CardPayingUX-div-19"
            style={{ gridRow: "5/6", gridColumn: "4/5", }}>
            <div
              id="CardPayingUX-div-44"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "Money transfer/QR Code" : "เงินโอน/QR Code"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-20"
            style={{ gridRow: "5/6", gridColumn: "5/7", margin: "2.5px 0" }}>
            <div
              className="ui label large fluid"
              id="txt-cashTransfer"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center",}}>
              {props.transferText}
            </div>
          </div>
          <div
            id="CardPayingUX-div-21"
            style={{ gridRow: "6/7", gridColumn: "4/5",  }}>
            <div
              id="CardPayingUX-div-45"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "Credit Card" : "บัตรเครดิต"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-22"
            style={{ gridRow: "6/7", gridColumn: "5/7", margin: "2.5px 0"  }}>
            <div
              className="ui label large fluid"
              id="txt-cashCreditCard"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.cardText}
            </div>
          </div>
          <div
            id="CardPayingUX-div-23"
            style={{ gridRow: "9/10", gridColumn: "4/5", ...((props.isDeposit || props.isCudent) && {gridRow: "8/9"})}}>
            <div
              id="CardPayingUX-div-46"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "Cashier's Check" : "แคชเชียร์เช็ค"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-24"
            style={{ gridRow: "9/10", gridColumn: "5/7", margin: "2.5px 0", ...((props.isDeposit || props.isCudent) && {gridRow: "8/9"})  }}>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-57"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.chequeText}
            </div>
          </div>
          <div
            id="CardPayingUX-div-25"
            style={{ gridRow: "10/11", gridColumn: "4/5", ...((props.isDeposit || props.isCudent) && {gridRow: "9/10"})  }}>
            <div
              id="CardPayingUX-div-47"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "Cash Coupon" : "คูปองเงินสด"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-26"
            style={{ gridRow: "10/11", gridColumn: "5/7", margin: "2.5px 0" , ...((props.isDeposit || props.isCudent) && {gridRow: "9/10"}) }}>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-58"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.couponText}
            </div>
          </div>
          <div
            id="CardPayingUX-div-27"
            style={{ gridRow: "12/13", gridColumn: "4/5", ...(props.isCudent && {gridRow: "10/11"}), ...(props.isDeposit && {gridRow: "11/12"})  }}>
            <div
              id="CardPayingUX-div-65"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "together" : "รวม"}
            </div>
          </div>
          <div
            className="ui label large fluid"
            id="CardPayingUX-div-28"
            style={{ gridRow: "12/13", gridColumn: "5/7", ...(props.isCudent && {gridRow: "10/11"}), ...(props.isDeposit && {gridRow: "11/12"})}}>
            {props.totalText}
          </div>
          <div
            id="CardPayingUX-div-29"
            style={{ gridRow: "4/5", gridColumn: "7/9", display: "flex", alignItems: "center" }}>
            <Button
              className="circular"
              color="green"
              icon="plus"
              id="CardPayingUX-Button-78"
              size="mini"
              style={{opacity: 0, margin: "3px 10px", pointerEvents: "none"}}>
            </Button>
            <label
              id="CardPayingUX-label-77"
              style={{fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Ton" : "ทอน"}
            </label>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-79"
              style={{marginLeft: "15px", textAlign: "right"}}>
              {props.changeText }
            </div>
          </div>
          <div
            id="CardPayingUX-div-30"
            style={{ gridArea: "5 / 7 / 6 / 9", display: "flex", alignItems: "center"}}>
            <Button
              className="circular"
              color="green"
              icon="plus"
              id="CardPaying-Button-AddPaymentMethod-2"
              onClick={()=> props.onAddPaymentMethod(2)}
              size="mini"
              style={{margin: "3px 10px"}}>
            </Button>
            <label
              id="CardPayingUX-label-75"
              style={{fontWeight: "bold", minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Reduce the change" : "ลดเศษสตางค์"}
            </label>
            <div
              className="ui label large fluid"
              id="CardPayingUX-div-76"
              style={{marginLeft: "15px", textAlign: "right"}}>
              {props.roundOffText || "\u00a0"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-31"
            style={{ gridRow: "6/7", gridColumn: "7/8" }}>
            <Button
              className="circular"
              color="green"
              icon="plus"
              id="CardPaying-Button-AddPaymentMethod-3"
              onClick={()=> props.onAddPaymentMethod(3)}
              size="mini"
              style={{margin: "3px 10px"}}>
            </Button>
          </div>
          <div
            id="CardPayingUX-div-32"
            style={{ gridRow: "9/10", gridColumn: "7/8", ...((props.isDeposit || props.isCudent) && {gridRow: "8/9"}) }}>
            <Button
              className="circular"
              color="green"
              icon="plus"
              id="CardPaying-Button-AddPaymentMethod-4"
              onClick={()=> props.onAddPaymentMethod(4)}
              size="mini"
              style={{margin: "3px 10px"}}>
              
            </Button>
          </div>
          <div
            id="CardPayingUX-div-33"
            style={{ gridRow: "10/11", gridColumn: "7/8", ...((props.isDeposit || props.isCudent) && {gridRow: "9/10"})}}>
            <Button
              className="circular"
              color="green"
              icon="plus"
              id="CardPaying-Button-AddPaymentMethod-5"
              onClick={()=> props.onAddPaymentMethod(5)}
              size="mini"
              style={{margin: "3px 10px"}}>
            </Button>
          </div>
          <div
            id="CardPayingUX-div-80"
            style={{ gridArea: "3 / 1 / 4/ 9" , margin: "20px 0" }}>
            {props.ErrorMessage}
          </div>
          <div
            id="CardPayingUX-div-74"
            style={{ gridArea: "13 / 1 / 13/ 9" , margin: "10px 0" , padding: "0 2rem"}}>
            {props.SubRepeaterPayMethod}
          </div>
          <div
            id="CardPaying-Div-PayingHeader"
            style={{ gridArea: "3 / 1 / 4/ 9" , margin: "20px 0" }}>
            {props.Loader}
          </div>
          <div
            id="CardPayingUX-div-125"
            style={{ gridRow: "15/16", gridColumn: "1/2",  marginRight: "1rem", ...((props.isCudent  || props.isDeposit) && { display: "none" })}}>
            
            <div
              id="CardPayingUX-div-126"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "Doctor's name on the receipt" : "ชื่อแพทย์บนใบเสร็จ"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-127"
            style={{ gridRow: "15/16", gridColumn: "2/4",marginRight: "1rem", marginLeft: "-1rem", alignItems: "center", ...((props.isCudent  || props.isDeposit) && { display: "none" }) }}>
            
            <div
              id="CardPayingUX-div-128">
              {props.doctorDropDown}
            </div>
          </div>
          <div
            id="CardPayingUX-div-34"
            style={{ gridRow: "15/16", gridColumn: "4/6",  marginRight: "1rem"}}>
            <div
              id="CardPayingUX-div-61"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "Patient name on receipt" : "ชื่อผู้ป่วยบนใบเสร็จ"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-35"
            style={{ gridRow: "15/16", gridColumn: "6/8",marginRight: "1rem", marginLeft: "-1rem", alignItems: "center"  }}>
            <div
              id="CardPayingUX-div-129">
              {props.patientDropDown}
            </div>
          </div>
          <div
            id="CardPayingUX-div-36"
            style={{ gridRow: "15/16", gridColumn: "8/9" }}>
            <Button
              color="green"
              disabled={props.cannotPay}
              id="CardPayingUX-Button-59"
              onClick={props.onPay}
              style={{ width: "100%" }}>
              {props.languageUX === "en" ? "Receive payment" : "รับชำระเงิน"}
            </Button>
          </div>
          <div
            id="CardPayingUX-div-88"
            style={{ gridRow: "13/16", gridColumn: "8/9" , pointerEvents: "none"}}>
            
          </div>
          <div
            id="CardPayingUX-div-82"
            style={{ gridRow: "11/12", gridColumn: "4/5", ...(props.isCudent && {display: "none"}), ...(props.isDeposit && {gridRow: "10/11"})  }}>
            
            <div
              id="CardPayingUX-div-86"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              {props.languageUX === "en" ? "Installment Payment" : "ผ่อนชำระ"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-83"
            style={{ gridRow: "11/12", gridColumn: "5/7", margin: "2.5px 0", ...(props.isCudent && {display: "none"}),  ...(props.isDeposit && {gridRow: "10/11"})  }}>
            
            <div
              className="ui label large fluid"
              id="txt-cashInstallment"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.installmentText}
            </div>
          </div>
          <div
            id="CardPayingUX-div-84"
            style={{ gridRow: "11/12", gridColumn: "7/8", ...(props.isCudent && {display: "none"}), ...(props.isDeposit && {gridRow: "10/11"})  }}>
            
            <Button
              className="circular"
              color="green"
              icon="plus"
              id="CardPaying-Button-AddPaymentMethod-7"
              onClick={()=> props.onAddPaymentMethod(7)}
              size="mini"
              style={{margin: "3px 10px"}}>
            </Button>
          </div>
          <div
            id="CardPayingUX-div-94"
            style={{ gridArea: "14 / 1 / 15 / 9" , margin: "-1.75em 0px -1em", padding: "0 2rem" }}>
            
            <div
              className="ui divider"
              id="CardPayingUX-div-114"
              style={{width: "100%"}}>
              
            </div>
            <Form
              className={`inline${props.showAutoEDC ? "": " hidden"}`}
              id="CardPayingUX-Form-95">
              <FormGroup
                id="CardPayingUX-FormGroup-96"
                inline={true}>
                <FormField
                  id="CardPayingUX-FormField-97"
                  inline={true}
                  width={2}>
                  <Checkbox
                    checked={props.check || false}
                    id="CardPayingUX-Checkbox-98"
                    label={props.languageUX === "en" ? "Auto EDC" : "ออโต้ อีดีซี"}
                    name="check"
                    onChange={props.onChangeAutoEDC}
                    style={{fontWeight: "bold",minWidth: "max-content"}}>
                  </Checkbox>
                </FormField>
                <FormField
                  id="CardPayingUX-FormField-99"
                  inline={true}
                  width={5}>
                  <label
                    id="CardPayingUX-label-101"
                    style={{minWidth: "max-content", width:  "140px"}}>
                    {props.languageUX === "en" ? "Approval Type" : "ประเภทการอนุมัติ"}
                  </label>
                  <Dropdown
                    disabled={!props.check}
                    fluid={true}
                    id="CardPayingUX-Dropdown-100"
                    name="approvalType"
                    onChange={props.onChangeAutoEDC}
                    options={[{key:1, text: "เจ้าของสิทธิ", value: "SELF"},{key:2, text: "บุตรธิดา", value: "CHILD"},{key:3, text: "ชาวต่างชาติ", value: "FOREIGNER"},{key:4, text: "ไม่มีบัตร", value: "NO_CARD"}]}
                    selection={true}
                    style={{width: "100%"}}
                    value={props.approvalType || ""}>
                  </Dropdown>
                </FormField>
                <FormField
                  id="CardPayingUX-FormField-102"
                  inline={true}
                  width={4}>
                  <label
                    id="CardPayingUX-label-103"
                    style={{minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Trace ID" : "รหัสติดตาม"}
                  </label>
                  <Input
                    disabled={props.check || false}
                    id="CardPayingUX-Input-104"
                    name="traceId"
                    onChange={props.onChangeAutoEDC}
                    placeholder={props.languageUX === "en" ? "Trace ID" : "รหัสติดตาม"}
                    value={props.traceId || ""}>
                  </Input>
                </FormField>
                <FormField
                  id="CardPayingUX-FormField-105"
                  inline={true}
                  width={5}>
                  <label
                    id="CardPayingUX-label-106"
                    style={{minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Approval Code" : "รหัสอนุมัติ"}
                  </label>
                  <Input
                    disabled={props.check || false}
                    id="CardPayingUX-Input-107"
                    name="approvalCode"
                    onChange={props.onChangeAutoEDC}
                    placeholder={props.languageUX === "en" ? "Approval Code" : "รหัสอนุมัติ"}
                    value={props.approvalCode || ""}>
                  </Input>
                </FormField>
              </FormGroup>
              <FormGroup
                id="CardPayingUX-FormGroup-108"
                inline={true}>
                <FormField
                  id="CardPayingUX-FormField-109"
                  inline={true}
                  width={2}>
                </FormField>
                <FormField
                  id="CardPayingUX-FormField-110"
                  inline={true}
                  width={5}>
                  <label
                    id="CardPayingUX-label-111"
                    style={{minWidth: "max-content", width: "130px"}}>
                    {props.languageUX === "en" ? "EDC Amount" : "จำนวนเงิน EDC"}
                  </label>
                  <Input
                    id="CardPayingUX-Input-113"
                    readOnly={true}
                    ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                    value={props.sumAmount.price || ""}>
                  </Input>
                </FormField>
              </FormGroup>
            </Form>
          </div>
          <div
            id="CardPayingUX-div-115"
            style={{ gridRow: "8/9", gridColumn: "4/5",  ...(props.isDeposit && {display: "none"})  }}>
            
            <div
              id="CardPayingUX-div-118"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", ...((props.isDeposit || props.isCudent) && {display: "none"}) }}>
              {props.languageUX === "en" ? "Deposit" : "เงินมัดจำ"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-116"
            style={{ gridRow: "8/9", gridColumn: "5/7", margin: "2.5px 0", ...(props.isDeposit && {display: "none"}), ...(props.isCudent && {display: "none"})  }}>
            
            <div
              className="ui input"
              id="CardPayingUX-div-121"
              style={{ width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              
              <input
                id="CardPaying-Input-CashDeposit"
                name="cashDepositText"
                onBlur={props.onBlurCashDepositText}
                onChange={props.onChangeCashDepositText}
                onKeyUp={props.onEnterCashDepositText}
                style={{  textAlign: "right" }}
                value={props.cashDepositText}>
              </input>
            </div>
          </div>
          <div
            id="CardPayingUX-div-117"
            style={{ gridRow: "8/9", gridColumn: "7/9", display: (props.isDeposit || props.isCudent) ? "none": "flex", alignItems: "center" }}>
            
            <Button
              className="circular"
              icon="plus"
              id="CardPayingUX-Button-123"
              size="mini"
              style={{margin: "3px 10px", opacity:0, pointerEvents: "none"}}>
            </Button>
            <label
              id="CardPayingUX-label-124"
              style={{fontWeight: "bold", minWidth: "max-content"}}>
              {props.languageUX === "en" ? "remaining" : "คงเหลือ"}
            </label>
            <div
              className="ui label large fluid "
              id="CardPayingUX-div-120"
              style={{marginLeft: "15px", textAlign: "right"}}>
              {props.depositTotal || "0.00"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-134"
            style={{ gridRow: "7/8", gridColumn: "4/5",  }}>
            
            <div
              id="CardPayingUX-div-137"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.languageUX === "en" ? "Debit Card" : "บัตรเดบิต"}
            </div>
          </div>
          <div
            id="CardPayingUX-div-135"
            style={{ gridRow: "7/8", gridColumn: "5/7", margin: "2.5px 0"  }}>
            
            <div
              className="ui label large fluid"
              id="txt-cashDebitCard"
              style={{ paddingRight: "10px", width : "100%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
              {props.cardDebitText}
            </div>
          </div>
          <div
            id="CardPayingUX-div-136"
            style={{ gridRow: "7/8", gridColumn: "7/8" }}>
            
            <Button
              className="circular"
              color="green"
              icon="plus"
              id="CardPayingUX-Button-138"
              onClick={()=> props.onAddPaymentMethod(9)}
              size="mini"
              style={{margin: "3px 10px"}}>
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardPayingUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Thu Oct 09 2025 17:23:33 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\", padding: \"10px\", marginTop:\"-1rem\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"rowGap\":\"5px\",\"gridTemplateColumns\":\"repeat(8, 1fr)\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", gridRow: \"1/2\", gridColumn: \"1/3\",display: \"none\"  }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", gridRow: \"1/2\", gridColumn: \"3/6\",display: \"none\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"7/9\",display: \"none\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"1/2\",  }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"2/4\", margin: \"2.5px 0\"  }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"1/2\",  }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"2/4\", margin: \"2.5px 0\"  }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"1/2\",  }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"2/4\", margin: \"2.5px 0\"  }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/8\", gridColumn: \"1/2\",  }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/8\", gridColumn: \"2/4\", margin: \"2.5px 0\"  }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"8/9\", gridColumn: \"1/2\", }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"8/9\", gridColumn: \"2/4\", margin: \"2.5px 0\"  }"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"9/10\", gridColumn: \"1/2\",  }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"9/10\", gridColumn: \"2/4\", margin: \"2.5px 0\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"4/5\", }"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"5/7\",  }"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"4/5\", }"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"5/7\", margin: \"2.5px 0\" }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"4/5\",  }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"5/7\", margin: \"2.5px 0\"  }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"9/10\", gridColumn: \"4/5\", ...((props.isDeposit || props.isCudent) && {gridRow: \"8/9\"})}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"9/10\", gridColumn: \"5/7\", margin: \"2.5px 0\", ...((props.isDeposit || props.isCudent) && {gridRow: \"8/9\"})  }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"10/11\", gridColumn: \"4/5\", ...((props.isDeposit || props.isCudent) && {gridRow: \"9/10\"})  }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"10/11\", gridColumn: \"5/7\", margin: \"2.5px 0\" , ...((props.isDeposit || props.isCudent) && {gridRow: \"9/10\"}) }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/13\", gridColumn: \"4/5\", ...(props.isCudent && {gridRow: \"10/11\"}), ...(props.isDeposit && {gridRow: \"11/12\"})  }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.totalText"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"12/13\", gridColumn: \"5/7\", ...(props.isCudent && {gridRow: \"10/11\"}), ...(props.isDeposit && {gridRow: \"11/12\"})}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"4/5\", gridColumn: \"7/9\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{ gridArea: \"5 / 7 / 6 / 9\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"7/8\" }"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"9/10\", gridColumn: \"7/8\", ...((props.isDeposit || props.isCudent) && {gridRow: \"8/9\"}) }"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"10/11\", gridColumn: \"7/8\", ...((props.isDeposit || props.isCudent) && {gridRow: \"9/10\"})}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"15/16\", gridColumn: \"4/6\",  marginRight: \"1rem\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"15/16\", gridColumn: \"6/8\",marginRight: \"1rem\", marginLeft: \"-1rem\", alignItems: \"center\"  }"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"15/16\", gridColumn: \"8/9\" }"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ค่าใช้จ่ายทั้งหมด",
          "valueEN": "Total expenses"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", fontWeight: \"bold\" }"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกได้",
          "valueEN": "Claimable"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", fontWeight: \"bold\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Non Claimable"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", fontWeight: \"bold\" }"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด",
          "valueEN": "discount"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", fontWeight: \"bold\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "ต้องชำระ",
          "valueEN": "Must pay"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", fontWeight: \"bold\" }"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้างชำระ",
          "valueEN": "Overdue"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", fontWeight: \"bold\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินสด",
          "valueEN": "cash"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินโอน/QR Code",
          "valueEN": "Money transfer/QR Code"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "บัตรเครดิต",
          "valueEN": "Credit Card"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "แคชเชียร์เช็ค",
          "valueEN": "Cashier's Check"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "คูปองเงินสด",
          "valueEN": "Cash Coupon"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.sumAmount.price"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\" }"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.sumAmount.reimbursable"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "(props.sumAmount.cashonly || 0)"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-50"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "(props.sumAmount.discount || 0)"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "(props.sumAmount.payable || 0)"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "props.oweText"
        },
        "className": {
          "type": "code",
          "value": "`ui label large fluid ${Number(props.rawOweText) > Number(props.totalText) ? \"red\" : \"green\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui input"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": "props.transferText"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "txt-cashTransfer"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\",}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardText"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "txt-cashCreditCard"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "props.chequeText"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.couponText"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Button",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงิน",
          "valueEN": "Receive payment"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.cannotPay"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Button-59"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPay"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ป่วยบนใบเสร็จ",
          "valueEN": "Patient name on receipt"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงิน (Paying)",
          "valueEN": "Paying"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"center\", alignItems: \"center\", fontWeight: \"bold\" }"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "รวม",
          "valueEN": "together"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "input",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPaying-Input-CashAmount"
        },
        "onBlur": {
          "type": "code",
          "value": "props.onBlurCashAmountText"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCashAmountText",
          "valueEN": ""
        },
        "onKeyUp": {
          "type": "code",
          "value": "props.onEnterCashAmountText"
        },
        "style": {
          "type": "code",
          "value": "{  textAlign: \"right\" }"
        },
        "value": {
          "type": "code",
          "value": "props.cashAmountText"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Label",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.citizenID || \"-\"}`"
        },
        "className": {
          "type": "value",
          "value": "large tag blue"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Label-68"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Label",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientNameAndHN"
        },
        "className": {
          "type": "value",
          "value": "ribbon large title blue"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Label-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Button",
      "parent": 30,
      "props": {
        "className": {
          "type": "value",
          "value": "circular"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPaying-Button-AddPaymentMethod-2"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(2)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"3px 10px\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Button",
      "parent": 31,
      "props": {
        "className": {
          "type": "value",
          "value": "circular"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPaying-Button-AddPaymentMethod-3"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(3)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"3px 10px\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Button",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "circular"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPaying-Button-AddPaymentMethod-4"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(4)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"3px 10px\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Button",
      "parent": 33,
      "props": {
        "className": {
          "type": "value",
          "value": "circular"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPaying-Button-AddPaymentMethod-5"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(5)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"3px 10px\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SubRepeaterPayMethod"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{ gridArea: \"13 / 1 / 13/ 9\" , margin: \"10px 0\" , padding: \"0 2rem\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "ลดเศษสตางค์",
          "valueEN": "Reduce the change"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-label-75"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "code",
          "value": "props.roundOffText || \"\\u00a0\""
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\", textAlign: \"right\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "ทอน",
          "valueEN": "Ton"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-label-77"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Button",
      "parent": 29,
      "props": {
        "className": {
          "type": "value",
          "value": "circular"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Button-78"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 0, margin: \"3px 10px\", pointerEvents: \"none\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "props.changeText "
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\", textAlign: \"right\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{ gridArea: \"3 / 1 / 4/ 9\" , margin: \"20px 0\" }"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.Loader"
        },
        "id": {
          "type": "value",
          "value": "CardPaying-Div-PayingHeader"
        },
        "style": {
          "type": "code",
          "value": "{ gridArea: \"3 / 1 / 4/ 9\" , margin: \"20px 0\" }"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"11/12\", gridColumn: \"4/5\", ...(props.isCudent && {display: \"none\"}), ...(props.isDeposit && {gridRow: \"10/11\"})  }"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"11/12\", gridColumn: \"5/7\", margin: \"2.5px 0\", ...(props.isCudent && {display: \"none\"}),  ...(props.isDeposit && {gridRow: \"10/11\"})  }"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"11/12\", gridColumn: \"7/8\", ...(props.isCudent && {display: \"none\"}), ...(props.isDeposit && {gridRow: \"10/11\"})  }"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 83,
      "props": {
        "children": {
          "type": "code",
          "value": "props.installmentText"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "txt-cashInstallment"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "ผ่อนชำระ",
          "valueEN": "Installment Payment"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\" }"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Button",
      "parent": 84,
      "props": {
        "className": {
          "type": "value",
          "value": "circular"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPaying-Button-AddPaymentMethod-7"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(7)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"3px 10px\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"13/16\", gridColumn: \"8/9\" , pointerEvents: \"none\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"3/4\", gridColumn: \"1/9\", padding: \"10px\", display: \"flex\", margin: \"0.5rem 0\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Label",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientNameAndHN"
        },
        "className": {
          "type": "value",
          "value": "ribbon large title blue"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Label-90"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Label",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.citizenID || \"-\"}`"
        },
        "className": {
          "type": "value",
          "value": "large tag blue"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Label-91"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5rem\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{ gridArea: \"14 / 1 / 15 / 9\" , margin: \"-1.75em 0px -1em\", padding: \"0 2rem\" }"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Form",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`inline${props.showAutoEDC ? \"\": \" hidden\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Form-95"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormGroup",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-FormGroup-96"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-FormField-97"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "Checkbox",
      "parent": 97,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.check || false"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Checkbox-98"
        },
        "label": {
          "type": "value",
          "value": "ออโต้ อีดีซี",
          "valueEN": "Auto EDC"
        },
        "name": {
          "type": "value",
          "value": "check"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeAutoEDC"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",minWidth: \"max-content\"}"
        },
        "toggle": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-FormField-99"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "Dropdown",
      "parent": 99,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.check"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Dropdown-100"
        },
        "name": {
          "type": "value",
          "value": "approvalType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeAutoEDC"
        },
        "options": {
          "type": "code",
          "value": "[{key:1, text: \"เจ้าของสิทธิ\", value: \"SELF\"},{key:2, text: \"บุตรธิดา\", value: \"CHILD\"},{key:3, text: \"ชาวต่างชาติ\", value: \"FOREIGNER\"},{key:4, text: \"ไม่มีบัตร\", value: \"NO_CARD\"}]"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.approvalType || \"\""
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "label",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทการอนุมัติ",
          "valueEN": "Approval Type"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-label-101"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", width:  \"140px\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "label",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสติดตาม",
          "valueEN": "Trace ID"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-label-103"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "Input",
      "parent": 102,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.check || false"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Input-104"
        },
        "name": {
          "type": "value",
          "value": "traceId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeAutoEDC"
        },
        "placeholder": {
          "type": "value",
          "value": "รหัสติดตาม",
          "valueEN": "Trace ID"
        },
        "value": {
          "type": "code",
          "value": "props.traceId || \"\""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-FormField-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสอนุมัติ",
          "valueEN": "Approval Code"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-label-106"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Input",
      "parent": 105,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.check || false"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Input-107"
        },
        "name": {
          "type": "value",
          "value": "approvalCode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeAutoEDC"
        },
        "placeholder": {
          "type": "value",
          "value": "รหัสอนุมัติ",
          "valueEN": "Approval Code"
        },
        "value": {
          "type": "code",
          "value": "props.approvalCode || \"\""
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormGroup",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-FormGroup-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormField",
      "parent": 108,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-FormField-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormField",
      "parent": 108,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-FormField-110"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "label",
      "parent": 110,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนเงิน EDC",
          "valueEN": "EDC Amount"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-label-111"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", width: \"130px\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Input",
      "parent": 110,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingUX-Input-113"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "value": {
          "type": "code",
          "value": "props.sumAmount.price || \"\""
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"8/9\", gridColumn: \"4/5\",  ...(props.isDeposit && {display: \"none\"})  }"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-116"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"8/9\", gridColumn: \"5/7\", margin: \"2.5px 0\", ...(props.isDeposit && {display: \"none\"}), ...(props.isCudent && {display: \"none\"})  }"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-117"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"8/9\", gridColumn: \"7/9\", display: (props.isDeposit || props.isCudent) ? \"none\": \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 115,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินมัดจำ",
          "valueEN": "Deposit"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", ...((props.isDeposit || props.isCudent) && {display: \"none\"}) }"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "code",
          "value": "props.depositTotal || \"0.00\""
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid "
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\", textAlign: \"right\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 116,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui input"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "input",
      "parent": 121,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPaying-Input-CashDeposit"
        },
        "name": {
          "type": "value",
          "value": "cashDepositText"
        },
        "onBlur": {
          "type": "code",
          "value": "props.onBlurCashDepositText"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeCashDepositText"
        },
        "onKeyUp": {
          "type": "code",
          "value": "props.onEnterCashDepositText"
        },
        "style": {
          "type": "code",
          "value": "{  textAlign: \"right\" }"
        },
        "value": {
          "type": "code",
          "value": "props.cashDepositText"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "Button",
      "parent": 117,
      "props": {
        "className": {
          "type": "value",
          "value": "circular"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Button-123"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"3px 10px\", opacity:0, pointerEvents: \"none\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "label",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": "คงเหลือ",
          "valueEN": "remaining"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-label-124"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-125"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"15/16\", gridColumn: \"1/2\",  marginRight: \"1rem\", ...((props.isCudent  || props.isDeposit) && { display: \"none\" })}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 125,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อแพทย์บนใบเสร็จ",
          "valueEN": "Doctor's name on the receipt"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-126"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"15/16\", gridColumn: \"2/4\",marginRight: \"1rem\", marginLeft: \"-1rem\", alignItems: \"center\", ...((props.isCudent  || props.isDeposit) && { display: \"none\" }) }"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorDropDown"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-128"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientDropDown"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-129"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงิน (Paying)",
          "valueEN": "Paying"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", paddingRight: \"10px\",  height: \"100%\", display: \"flex\", justifyContent: \"center\", alignItems: \"center\", fontWeight: \"bold\" }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\", width: \"250px\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Label",
      "parent": 132,
      "props": {
        "children": {
          "type": "code",
          "value": "props.receiptCode"
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Label-133"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", paddingRight: \"10px\",  height: \"100%\", display: \"flex\", alignItems: \"center\", fontWeight: \"bold\" }"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/8\", gridColumn: \"4/5\",  }"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-135"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/8\", gridColumn: \"5/7\", margin: \"2.5px 0\"  }"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"7/8\", gridColumn: \"7/8\" }"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": "บัตรเดบิต",
          "valueEN": "Debit Card"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-div-137"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Button",
      "parent": 136,
      "props": {
        "className": {
          "type": "value",
          "value": "circular"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPayingUX-Button-138"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(9)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"3px 10px\"}"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 135,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardDebitText"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "txt-cashDebitCard"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"10px\", width : \"100%\", height: \"100%\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\", }"
        }
      },
      "seq": 139,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 45,
  "isMounted": false,
  "memo": false,
  "name": "CardPayingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 60
}

*********************************************************************************** */
